import React, {useContext} from 'react';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';
import PrivacyPolicyDe from './de/PrivacyPolicyDe';
import EssentialCookieInfoDe from './de/EssentialCookieInfoDe';
import EssentialCookieInfoEn from './en/EssentialCookieInfoEn';


export function EssentialCookieInfo(props) {
    const locale = useContext(LocaleContext);

    return (
        <div>
            <div className="flex_col">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <EssentialCookieInfoDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <EssentialCookieInfoEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>
        </div>
    );
}
